import { ReactElement, useMemo, useState } from 'react'
import { StyledDescription, ReadMore } from './styles'
import { ProfileTabProps } from './props'
import { Divider, Image, List, Text } from '../../../../Atoms'
import { Grid } from '../../../../Molecules'
import { TrygImage } from '../../../../Assets/Images'

const ProfileTab = ({
    educationText,
    educations = [],
    profileText = '',
    readMoreLength = 500,
    readMoreText = () => 'Read more',
}: ProfileTabProps): ReactElement => {
    const [readMore, setReadMore] = useState<boolean>(
        profileText.length < readMoreLength
    )
    const shouldShowReadMoreButton = useMemo(
        () => profileText.length > readMoreLength,
        [profileText.length, readMoreLength]
    )

    const description = useMemo(
        () => (
            <StyledDescription>
                {readMore
                    ? profileText
                    : `${profileText.substring(0, readMoreLength)}...`}
                {shouldShowReadMoreButton && (
                    <ReadMore onClick={() => setReadMore(!readMore)}>
                        {readMoreText(readMore)}
                    </ReadMore>
                )}
            </StyledDescription>
        ),
        [
            profileText,
            readMore,
            readMoreLength,
            readMoreText,
            shouldShowReadMoreButton,
        ]
    )

    const educationTexts = useMemo(
        () => (
            <Grid>
                {educationText && (
                    <Text css={{ color: '$neutral400' }}>{educationText}</Text>
                )}
                <List
                    items={
                        Array.isArray(educations) ? educations : [educations]
                    }
                    listType="ul"
                    listStyleType="disc"
                />
            </Grid>
        ),
        [educationText, educations]
    )

    return (
        <Grid
            autoFlow={{ '@desktop': 'column' }}
            css={{
                alignItems: 'start',
                justifyContent: 'start',
            }}
            gap="16"
        >
            <Grid gap="16" css={{ '@desktop': { maxW: 200 } }}>
                <Image src={TrygImage} css={{ h: 20 }} />
                {educationTexts}
            </Grid>
            <Divider orientation={{ '@mobile': 'horizontal' }} />
            {description}
        </Grid>
    )
}

export default ProfileTab
